import styled, { css } from 'styled-components';

export interface SpacerStyleProps {
  minWidth?: string;
  maxWidth?: string;
  minHeight?: string;
  maxHeight?: string;
  hideOnMobile?: boolean;
}

export const SpacerContainer = styled.div<SpacerStyleProps>`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  min-width: 0;
  min-height: 0;

  ${({ minWidth }) =>
    minWidth &&
    css`
      min-width: ${minWidth};
    `}
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `}
  ${({ minHeight }) =>
    minHeight &&
    css`
      min-height: ${minHeight};
    `}
  ${({ maxHeight }) =>
    maxHeight &&
    css`
      max-height: ${maxHeight};
    `}
  ${({ hideOnMobile }) =>
    hideOnMobile &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}
`;
